import { connect } from 'react-redux';
import AlertBox from '../../../modules/common/AlertBox';
import {
  closeAlertDialogBox,
  clearAlertDialogData
} from '../../customizer.duck';

const mapStateToProps = state => ({
  alertInfo: state.customizer.alertInfo
});

const mapDispatchToProps = dispatch => ({
  closeAlertDialogBox: () => {
    dispatch(closeAlertDialogBox());
  },
  clearAlertDialogData: () => {
    dispatch(clearAlertDialogData());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertBox);
